import { Box, IconButton } from '@material-ui/core';
import { SEmptyState } from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';

interface EmptyStateProps {
  onClose: () => void;
}

export const ProductDetailsEmptyState = ({ onClose }: EmptyStateProps) => (
  <Box width="100%">
    <Box px={4} py={3} display="flex" flexDirection="row-reverse">
      <IconButton
        aria-label="close"
        size="small"
        style={{ height: 'fit-content' }}
        onClick={onClose}>
        <CloseIcon style={{ width: 27, height: 27 }} />
      </IconButton>
    </Box>
    <SEmptyState
      title="Product Not Found"
      subTitle="There is no product found with specified ID."
    />
  </Box>
);
